module.exports = __webpack_public_path__ + "img/MinistryLogo.ad5f1f01.png";